export default __webpack_public_path__ + "resources/icons/d241-bbf2.webp";